import { DefaultError, useQuery } from "@tanstack/react-query";

import { ITwoFactorStatusResponse } from "./types";
import { useResponseHandler } from "utils/service/responseHandler";
import { apiClient } from "utils";
import { cacheService } from "utils/service/cacheService";
import { useStoreState } from "providers/StoreStateContext";

export const TWO_FACTOR_STATUS_KEY = (userId?: string) =>
  ["twoFactorStatus", userId] as const;

export const useGetTwoFactorStatus = (userId?: string, enabled?: boolean) => {
  const { responseHandler } = useResponseHandler();

  return useQuery<ITwoFactorStatusResponse, DefaultError>({
    queryKey: TWO_FACTOR_STATUS_KEY(userId),
    queryFn: async () => {
      const response = await apiClient({
        method: "GET",
        url: "Auth/TwoFactorStatus",
        params: { UserId: userId },
      });

      return responseHandler(response, {
        groupName: "useGetTwoFactorStatus",
      });
    },
    ...cacheService(),
    enabled: enabled ?? !!userId,
  });
};
